import { ConsentSettings } from "@/types/gtm";

export const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID || '';

let gtmLoaded = false

// Mise à jour du consentement (sans effet tant que GTM n'est pas chargé)
export const updateConsent = (consent: Partial<ConsentSettings>) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('consent', 'update', consent);
  }
};

// Chargement de GTM, appelé uniquement une fois le consentement accordé
export const loadGtm = () => {
  if (typeof window === 'undefined' || !GTM_ID || gtmLoaded) return
  gtmLoaded = true

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };

  // Le consentement doit être dans le dataLayer avant le démarrage de GTM
  window.gtag('consent', 'default', {
    analytics_storage: 'granted',
    ad_storage: 'granted',
    functionality_storage: 'granted',
    personalization_storage: 'granted',
    security_storage: 'granted',
  });

  window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(script);
};
